import { tryCatchHelper } from '../../../helpers';
import { ACTIVO_JUEGOS, ALL_JUEGOS, LOADING_ALL_JUEGOS } from './JuegosReducer';
import {
  deleteJuegosService,
  allJuegosService,
  oneJuegosService,
  saveJuegosService,
} from './JuegosService';

export const allJuegosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_JUEGOS, payload: true });
    const res = await allJuegosService(params);
    dispatch({ type: ALL_JUEGOS, payload: res.data });
    dispatch({ type: LOADING_ALL_JUEGOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_JUEGOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveJuegosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveJuegosService(id, data);
    notify(res.data.message);
    await allJuegosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoJuegosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_JUEGOS, payload: data });
};

export const oneJuegosAction = async (dispatch, id) => {
  try {
    const res = await oneJuegosService(id);
    await setActivoJuegosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteJuegosAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteJuegosService(id);
    notify(res.data.message);
    await setActivoJuegosAction(dispatch, null);
    await allJuegosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
